
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ducks } from 'store/configureStore';

const useRedux = (...actions) => {

    const state = useSelector(state => state);

    const retActions = [];

    const dispatch = useDispatch();

    for (var i = 0; i < actions.length; i++) {
        retActions.push(bindActionCreators(actions[i], dispatch));
    }

    return [state, ...retActions];
}

//example of usage 
//const [[portfolio, actions], [shoppingCart, shoppingCartActions]] = useDuck('portfolio', 'shoppingCart');
export const useDuck = (...storeNames) => {

    const state = useSelector(state => state);
    const dispatch = useDispatch();

    var ret = [];
    var ret2 = {};

    for (var i = 0; i < storeNames.length; i++) {
        var name = storeNames[i];

        const duck = ducks[name];

        const v = {
            state: state[name],
            actions: bindActionCreators(duck, dispatch)
        };

        ret2[name] = v;

        ret.push([state[name], bindActionCreators(duck, dispatch)]);
    }

    return ret;
}

export default useRedux;


// WEBPACK FOOTER //
// ./src/hooks/useRedux.js